import theme from '@/theme';
import styled from '@emotion/styled';

const CodeSection = styled('div')`
    display: block;
    padding: 20px 20px 8px;
    margin-top: 16px;
    position: relative;
    border-radius: 8px;
    background-color: ${theme.colors.settings};
    overflow-x: hidden;
    max-width: 500px;
`;

const StyledCode = styled('code')`
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-family: Mulish, sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    word-wrap: normal;
    text-align: left;
    display: block;
    padding-bottom: 8px;
`;

const StyledPre = styled('div')`
    overflow: auto;
    word-wrap: break-word;
    white-space: pre;
    max-width: 100%;
`;

interface Props {
    code: string;
}

export const EmbedSnippet = ({ code }: Props) => {
    return (
        <CodeSection>
            <StyledPre>
                <StyledCode>{code.trim()}</StyledCode>
            </StyledPre>
        </CodeSection>
    );
};
